"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const CardHeader_1 = __importDefault(require("@material-ui/core/CardHeader"));
const styles_1 = require("@material-ui/core/styles");
const Text_1 = __importDefault(require("../Text"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: ({ withHover }) => (Object.assign({}, (withHover && {
        '&:hover': {
            backgroundColor: theme.palette.info.light,
        },
    }))),
}));
/**
 * A Card renders the basic information of a resource
 * */
const Card = (_a) => {
    var { title = '', subtitle = '', titleTypographyProps, children, onClick, onMouseEnter, onMouseMove, onMouseOut, withHover } = _a, props = __rest(_a, ["title", "subtitle", "titleTypographyProps", "children", "onClick", "onMouseEnter", "onMouseMove", "onMouseOut", "withHover"]);
    const styles = useStyles({ withHover });
    const testId = props['data-testid'] || 'card';
    const content = react_1.useMemo(() => (react_1.default.createElement(CardContent_1.default, { "data-testid": `${testId}-content` }, typeof children === 'string' ? react_1.default.createElement(Text_1.default, { variant: "p" }, children) : children)), [children, testId]);
    return (react_1.default.createElement(Card_1.default, { className: styles.root, onClick: onClick, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseOut: onMouseOut, "data-testid": testId },
        react_1.default.createElement(CardHeader_1.default, { title: title, subheader: subtitle, titleTypographyProps: titleTypographyProps, "data-testid": `${testId}-header` }),
        content));
};
exports.default = Card;
//# sourceMappingURL=index.js.map